import React from "react";  
import { Home, 
        CaretRight, 
        TrendingDown, 
        Notebook, 
        List, 
        ClipboardCheck,
        Bed, 
        UserPlus } from 'tabler-icons-react'; 
import VisitorList2 from './common/visitorlist2';
import ExistingPatient from './common/existingpatient';

import leftArrow from '../images/leftArrow.png' 
import btnHome from '../images/btnHomeIcon.png'
import iconcross from '../images/iconcross.png'


const WardRegExist = () => {
    return (
        <div className="topicSection"> 

            {/* HOME BUTTON SECTION */}
            <div className="btnHomeSection bounce-in-fwd10">
                <button type="button" className="btnCircle">
                    <img src={btnHome} alt="Date" height="50" width="50" /><br />
               HOME
            </button>
            </div> 

            <div className="headerSub">
                <div className="headerSubTitle headerSubLineTop scale-in-center">
                    <p>
                    YOU HAVE ALREADY BEEN REGISTERED TO THE BELOW PATIENTS
                    </p>
                </div>
            </div>

            <div className="headerName">
                <div className="headerTitle slide-in-top">
                    <div className="iconWard"></div>
                    <div className="iconNameTitle">WARD VISIT</div>
                </div>
            </div>


            {/* MAIN CONTENT SECTION */}
            <div className="contentPage">

                {/* BREADCRUMBS */}
                <div className="breadcrumbs">
                    <ul>
                        <li className="fcolorGreen"><Home size={50} strokeWidth={2} color={'green'} /> <span className="crumHome">HOME </span>
                            <TrendingDown size={25} strokeWidth={2} color={'green'} />
                        </li>
                        <li className="fcolorGreen"><Bed size={40} strokeWidth={2} color={'green'} />
                            <b><i> Step 1</i></b>
                            <br />
                         WARD VISIT <CaretRight size={40} strokeWidth={2} color={'green'} />
                        </li>
                        <li className="fcolorRed"><Notebook size={40} strokeWidth={2} color={'red'} />
                            <b><i> Step 2</i></b> <br />
                        REGISTRATION <CaretRight size={40} strokeWidth={2} color={'red'} />
                        </li>
                        <li className="fcolorGray"><List size={40} strokeWidth={2} color={'gray'} />
                            <b><i> Step 3</i></b> <br />
                        SUMMARY <CaretRight size={40} strokeWidth={2} color={'gray'} />
                        </li>
                        <li className="fcolorGray"><ClipboardCheck size={40} strokeWidth={2} color={'gray'} />
                            <b><i> Step 4</i></b> <br />
                        COMPLETE 
                        
                        {/* For White space */}
                        <CaretRight size={40} strokeWidth={2} color={'transparent'} />
                        </li>
                    </ul>

                </div> 

                {/* EXISTING TABLE SECTION  */} 
                {/* TABLE LIST HERE */}
                <ExistingPatient/>
 
                <div className="footerBtnLeft fade-in-left7">
                    <button type="button" className="btnCircle">
                        <img src={leftArrow} alt="Arrow Left" height="50" width="50" /><br />
                        BACK
                    </button>
                </div>

                {/* COMPLETE BUTTON */}
                <div className="footerBtnRight fade-in-left8 btnPosEnd">
                    <button type="button" className="btnCircleRed">
                        <img src={iconcross} alt="Arrow Right" height="50" width="50" /><br />
                        CANCEL
                    </button>
                </div> 

                {/* ADD PATIENT BUTTON */}  
                <div className="footerBtnRight fade-in-left9 btnPosEnd2">
                    <button type="button" className="btnRdCorn">
                        <UserPlus size={35} strokeWidth={2} color={'white'} /><br />
                        <p>ADD PATIENT</p>
                    </button>
                </div>
 
                {/* VISITOR LIST SECTION */}
                <VisitorList2/>
 
            </div>
        </div>
    );
};

export default WardRegExist;